import { render, staticRenderFns } from "./DashboardLiveStatisticsTwoMatches.vue?vue&type=template&id=13c23c77&scoped=true"
import script from "./DashboardLiveStatisticsTwoMatches.vue?vue&type=script&lang=js"
export * from "./DashboardLiveStatisticsTwoMatches.vue?vue&type=script&lang=js"
import style0 from "./DashboardLiveStatisticsTwoMatches.vue?vue&type=style&index=0&id=13c23c77&prod&lang=scss"
import style1 from "./DashboardLiveStatisticsTwoMatches.vue?vue&type=style&index=1&id=13c23c77&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c23c77",
  null
  
)

export default component.exports